<app-nav></app-nav>
<section class="personalAccidentProposalThankYou" *ngIf="transactionSuccessSection">
    <div class="container">
      <div class="col">
        <h4 class="payment-title text-center mt-4">Payment Successful</h4>
        <div class="insurer-image text-center mt-4">
            <img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png"
              class="img-responsive" width="50%" alt="Religare Insurance">
          </div>
      </div>
      <div class="col download-document">
        <div class="insurer-image text-center">
            <img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/file-4.svg"
              class="img-responsive" width="20%" alt="Download Document">
          </div>
          <a href="{{downloadPdfLink}}" class="download-title text-center mt-3" target="_blank">Download Policy Document</a>
      </div>
      <div class="col contact-us text-center">
        <p class="title">For Endorsement and Claim Contact at:</p>
        <p class="call"><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone.svg"><span>1860-500-4488</span><span class="bar"></span><span>1800-102-4488</span></p>
        <p class="call"><span><img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/message.svg"></span>customerfirst@religarehealthinsurance.com</p>
      </div>
      <div class="col footer-strip text-center">
        <img
        src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
        class="img-responsive" width="40%" alt="Religare Insurance">
        <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
      </div>
    </div>
  </section>
  <section class="personalAccidentTransactionFailure" *ngIf="transactionFailureSection">
    <div class="container">
        <div class="col text-center failure-error">
          
          <div class="insurer-image mt-4">
              <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg"
                class="img-responsive" width="20%" alt="Error">
            </div>
            <h4 class="payment-title mt-4">Oops... Payment Failed</h4>
            <p>Transaction Id: {{transactionId}}</p>
            <p class="error-message">{{errorStatus}}</p>
            <p class="error-message">{{errorInternalMsg}}</p>
            <!--  -->
        </div>
        <div class="col failure-reasons">
          <ul class="oval">
            <li>The Card CVV or Expiry Date might be wrong</li>
            <li>Your Bank networks might be down</li>
          </ul>
          <div class="text-center mt-4">
            <button class="btn btn-bordered-blue">Try Again</button>
          </div>
        </div>
        <div class="col footer-strip text-center">
          <img
          src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
          class="img-responsive" width="40%" alt="Religare Insurance">
          <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span></p>
        </div>
      </div>
      <div id="spinner" [hidden]="!loading">
          <div class="spinnerfull">
            <i class="fa fa-spinner fa-spin fa-3x"></i>
          </div>
        </div>
  </section>
